module.exports = __webpack_public_path__ + "static/img/zoltan.f8e180c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/zoltan.png
// module id = I/x2
// module chunks = 0